<template>
  <div class="relative card p-0">
    <div v-if="$slots.header" class="border-b border-main px-6">
      <slot name="header"></slot>
    </div>
    <div v-if="$slots.subheader" class="border-b border-main px-6">
      <slot name="subheader"></slot>
    </div>
    <div :class="{ 'px-6': !noPadding, '': noPadding }">
      <slot></slot>
    </div>
    <div v-if="$slots.footer" class="border-t border-main p-6">
      <slot name="footer"></slot>
    </div>
    <div
      v-if="loading"
      data-testid="content-card-loading"
      class="absolute top-0 left-0 flex h-full w-full items-center justify-center bg-surface/70 backdrop-opacity-50"
    >
      <CircleSpinner /> <span v-if="!!progress" class="ml-3 text-body-l">{{ progress }}%</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { CircleSpinner } from '@ramp106/omrjs-core-ui'

defineProps<{
  noPadding?: boolean
  loading?: boolean
  progress?: number
}>()
</script>
